import { actions as labelActions } from 'actions/labels';

const service = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case labelActions.initLabels:
      return payload.service;
    default:
      return state;
  }
};

export default service;



// WEBPACK FOOTER //
// ./src/reducers/service.js